import type { TranslationInterface } from '.';

export const CzechLanguage: TranslationInterface = {
  write_a_message_placeholder: 'Napište zprávu...',
  your_issue_has_been_resolved: 'Váš problém byl vyřešen!',
  new_conversation: 'Nová konverzace',
  welcome_screen_title: 'Vítejte v našem chatu podpory',
  welcome_screen_description:
    'Jsme tu, abychom vám pomohli! Zahajte konverzaci a ozveme se vám co nejdříve.',
  your_name_placeholder: 'Vaše jméno',
  your_email_placeholder: 'Vaše e-mailová adresa',
  start_chat_button: 'Kontaktovat podporu',
  start_chat_button_loading: 'Připojování...',
  i_need_more_help: 'Potřebuji další pomoc',
  this_was_helpful: 'Toto bylo užitečné',
  optional: 'Volitelné',
  no_conversations_yet: 'Zatím žádné konverzace',
  back_to_conversations: 'Zpět na konverzace',
  closed_conversations: 'Uzavřené konverzace',
  csat_title: 'Jaká byla vaše konverzace?',
  csat_submitted_title: 'Konverzaci jste ohodnotili jako',
  csat_feedback_placeholder: 'Řekněte nám více... (nepovinné)',
  follow_up_placeholder: 'Pokračovat…',
  companion_layout_label: 'Rozvržení',
  companion_layout_floating: 'Plovoucí',
  companion_layout_sidebar: 'Postranní panel',
  companion_layout_fullscreen: 'Celá obrazovka',
  companion_close: 'Zavřít',
  companion_history: 'Historie konverzací',
  companion_expand_chat: 'Rozbalit chat',
  companion_sidebar_dock_label: 'Ukotvení',
  companion_sidebar_side_label: 'Strana',
  companion_sidebar_left: 'Vlevo',
  companion_sidebar_right: 'Vpravo',
  companion_resize_chat: 'Změnit velikost chatu',
  scroll_to_bottom: 'Posunout dolů',
  thinking: 'Přemýšlím…',
  running: 'Probíhá…',
  steps: 'kroky',
  step_arguments: 'Argumenty',
  step_result: 'Výsledek',
  attach_files:
    'Připojit obrázky, videa, PDF nebo tabulky (maximální velikost 25 MB)',
  mark_page_active:
    'Kliknutím na cokoli na stránce to označíte — klávesou Esc akci zrušíte',
  mark_page: 'Označte něco na stránce a zeptejte se na to',
  stop_response: 'Zastavit odpověď',
  copy_reply: 'Kopírovat odpověď',
  mentions_empty: 'Žádné shody',
  copied: 'Zkopírováno',
  send_message: 'Odeslat zprávu',
  upload_failed: 'Nahrání se nezdařilo: {error}',
  remove_attachment: 'Odebrat přílohu',
  json_no_items: 'Žádné položky',
  json_no_data: 'Žádná data',
  json_no_chart_data: 'Žádná data pro graf',
  json_unsupported: 'Nepodporováno: {type}',
  json_see_less: 'Zobrazit méně',
  json_phone_agent: 'Telefonní agent',
  json_phone_agent_test: 'Vyzkoušet na webu',
  page_context_remove: 'Odebrat kontext stránky',
  json_see_more: 'Zobrazit dalších {count}',
  queued_label: '{count} Ve frontě',
  remove_queued_message: 'Odebrat zprávu z fronty',
  send_queued_now: 'Odeslat zprávy ve frontě nyní',
  turn_failed_message: 'Něco se pokazilo a odpověď nedorazila.',
  turn_failed_retry: 'Zkusit znovu',
  page_mark_hint: 'Kliknutím na cokoli to označíte',
  page_mark_escape: 'Esc',
  page_mark_shape_box: 'Rámeček',
  page_mark_shape_circle: 'Kruh',
  page_mark_shape_arrow: 'Šipka',
  page_mark_shape_bracket: 'Závorka',
  page_mark_shape_underline: 'Podtržení',
  page_mark_shape_highlight: 'Zvýraznění',
  page_mark_shape_strike_through: 'Přeškrtnutí',
  page_mark_shape_crossed_off: 'Křížové přeškrtnutí',
  page_mark_shape_aria: 'Tvar označení: {shape}',
  page_mark_note_placeholder: 'Přidat poznámku… (Enter pro připojení)',
  page_mark_attach: 'Připojit označení',
  page_mark_remove: 'Odebrat {label}',
  page_mark_region: 'Označená oblast',
  page_mark_default_message: 'Co to je?',
  file_rejected: 'Typ souboru není podporován nebo je soubor příliš velký.',
  dictate: 'Diktovat',
  stop_dictation: 'Zastavit diktování',
  dictation_mic_blocked: 'Pro diktování povolte přístup k mikrofonu',
  dictation_unavailable: 'Diktování momentálně není k dispozici',
  questions_back: 'Zpět',
  questions_next: 'Další',
  questions_send: 'Odeslat',
  questions_type_answer: 'Napíšu to sám',
  questions_answer_placeholder: 'Napište svou odpověď…',
  close_conversation_title: 'Uzavřít konverzaci',
  close_conversation_description: 'Opravdu chcete tuto konverzaci uzavřít?',
  close_conversation_cancel: 'Ne',
  close_conversation_confirm: 'Ano',
  dialog_close: 'Zavřít',
  zoom_in: 'Přiblížit',
  zoom_out: 'Oddálit',
  reset_zoom: 'Obnovit přiblížení',
  support_chat_aria_label: 'Chat podpory',
};
